import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const RequirePaid = ({ children }) => {
  const { user, loading } = useAuth();
  const loc = useLocation();

  if (loading) {
    return <div className="min-h-screen grid place-items-center text-zinc-500">Loading…</div>;
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: loc }} replace />;
  }
  if (!user.paid) {
    return <Navigate to="/enroll" state={{ from: loc }} replace />;
  }
  return children;
};

export default RequirePaid;
